/**
 * Active-play clock: integer ms since round start, paused while the app is hidden or a
 * modal is open. Core actions carry this `t` (ADR 0001: the core never reads a clock).
 */
export class ActiveClock {
  private acc = 0;
  private since: number | null = null;
  private holds = new Set<string>();

  constructor(private readNow: () => number) {}

  get running(): boolean {
    return this.since !== null;
  }

  now(): number {
    return Math.floor(this.acc + (this.since === null ? 0 : this.readNow() - this.since));
  }

  /** Pause for a named reason (e.g. 'hidden', 'modal'); resumes when every hold is released. */
  hold(reason: string): void {
    this.holds.add(reason);
    if (this.since !== null) {
      this.acc += this.readNow() - this.since;
      this.since = null;
    }
  }

  release(reason: string): void {
    this.holds.delete(reason);
    if (this.holds.size === 0 && this.since === null) this.since = this.readNow();
  }

  start(): void {
    this.acc = 0;
    this.holds.clear();
    this.since = this.readNow();
  }
}
